import { h } from "@stencil/core";

export const ErrorButton = (props) => {
    switch (props.message.status) {
        case WorkflowState.Open: {
            return (
                <TakeOverButton
                    changeWorkflowStatus={(event, state) =>
                        props.changeWorkflowStatus(event, state)
                    }
                ></TakeOverButton>
            );
        }
        case WorkflowState.Committed: {
            if (props.message.commitedBy === props.userId) {
                return (
                    <div
                        class={`uic-message-list-item__message-dual-button-${props.variant}`}
                    >
                        <ReturnButton
                            changeWorkflowStatus={(event, state) =>
                                props.changeWorkflowStatus(event, state)
                            }
                        ></ReturnButton>
                        <CompleteButton
                            changeWorkflowStatus={(event, state) =>
                                props.changeWorkflowStatus(event, state)
                            }
                        ></CompleteButton>
                    </div>
                );
            } else if (props.variant === "max") {
                return (
                    <InProgressInfo
                        committedBy={props.message.commitedBy}
                        inProgressText={props.inProgressText}
                        read={props.message.read}
                    ></InProgressInfo>
                );
            }
            break;
        }
        case WorkflowState.Closed: {
            return (
                <ClosedInfo
                    variant={props.variant}
                    closedBy={props.message.closedBy}
                    acknowledgedByText={props.acknowledgedByText}
                    read={props.message.read}
                ></ClosedInfo>
            );
        }
    }
};

const TakeOverButton = (props) => (
    <uic-button
        size="icon"
        onClick={(event) => {
            props.changeWorkflowStatus(event, WorkflowState.Committed);
        }}
        class={`uic-message-list-item__message-button`}
        icon="uic:take-over"
    ></uic-button>
);

const ReturnButton = (props) => (
    <uic-button
        size="icon"
        onClick={(event) => {
            props.changeWorkflowStatus(event, WorkflowState.Open);
        }}
        class={`uic-message-list-item__message-button`}
        icon="uic:submit"
    ></uic-button>
);

const CompleteButton = (props) => (
    <uic-button
        size="icon"
        variant="content-primary"
        onClick={(event) => {
            props.changeWorkflowStatus(event, WorkflowState.Closed);
        }}
        class={`uic-message-list-item__message-button uic-message-list-item__message-button--second`}
        icon="uic:confirm"
    ></uic-button>
);

const InProgressInfo = (props) => (
    <div class="uic-message-list-item__message-committed-by">
        <div>
            <div
                class={`uic-message-list-item__message-committed-by-preset-text ${
                    !props.read ? "uic-message-list-item__new-message" : ""
                }`}
            >
                {props.inProgressText}
            </div>
            <div
                class={`uic-message-list-item__message-committed-by-username ${
                    !props.read
                        ? "uic-message-list-item__new-message--extrabold"
                        : ""
                }`}
            >
                {props.committedBy}
            </div>
        </div>
    </div>
);

const ClosedInfo = (props) => (
    <div class="uic-message-list-item__message-committed-by">
        {props.variant === "max" ? (
            <div>
                <div
                    class={`uic-message-list-item__message-committed-by-preset-text ${
                        !props.read ? "uic-message-list-item__new-message" : ""
                    }`}
                >
                    {props.acknowledgedByText}
                </div>

                <div
                    class={`uic-message-list-item__message-committed-by-username ${
                        !props.read
                            ? "uic-message-list-item__new-message--extrabold"
                            : ""
                    }`}
                >
                    {props.closedBy}
                </div>
            </div>
        ) : (
            <div></div>
        )}
        <uic-icon
            name="uic:completed"
            class={`uic-message-list-item__message-button--completed`}
        ></uic-icon>
    </div>
);

export enum WorkflowState {
    Open = "Open",
    Committed = "Commited",
    Closed = "Closed",
}
